import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Err from "../../../../../../../routes/error";
import { LOAD_SUBMISSION_HISTORY } from "../../../store/lender-submit-actions";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { LOAD_DOCUMENT_FORMS, TOGGLE_FORM_SELECTED, PRINT_SELECTED_FORMS, PRINT_DOCUMENT_FORM } from "../../../store/lender-submit-actions";
import { SET_DOCUMENT_FORM_SELECTION, SET_EDITING_DOCUMENT_FORM } from "../../../store/lender-submit-mutations";
import FormsTable from "./forms-table";
import FormFormulary from "./form-formulary";
import SubmissionHistoryHandler from "@Shared/utils/application-mixins/submission-history-mixin";
import { isEmpty, values } from "lodash";
import FormsPageLoader from "../../page-loaders/forms-page-loader.vue";
import { CURRENT_APPLICATION } from "../../../store/application-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FormsContainer",
  title() {
    return this.$t("sidebar.sections.application.forms");
  },
  components: {
    FormsTable,
    FormsPageLoader,
    FormFormulary
  },
  mixins: [SubmissionHistoryHandler],
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editing: false,
      loading: true,
      saving: false,
      printing: false,
      formToEdit: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", {
    documentForms(state) {
      return values(state.documentForms.byId[this.applicationId]) || [];
    },
    editingForm: "editingDocumentForm"
  })), mapGetters("ApplicationStore", ["getSubmissionHistory", CURRENT_APPLICATION])), {}, {
    canDownloadSelected() {
      return this.documentForms.some(({
        mortgagesSelected
      }) => mortgagesSelected == null ? void 0 : mortgagesSelected.length);
    },
    formSelectionEnabled() {
      const submissionHistories = this.getSubmissionHistory.byId;
      return this.validSubmissionExist(submissionHistories);
    },
    currentMortgages() {
      const {
        "submission-details": submissionDetails = {}
      } = this.CURRENT_APPLICATION;
      return _reduceInstanceProperty(submissionDetails).call(submissionDetails, (acc, submissionDetail = {}) => {
        const mortgageType = submissionDetail && submissionDetail["submission-details"]["mortgage-type"];
        if (mortgageType) acc.push(mortgageType);
        return acc;
      }, []);
    }
  }),
  mounted() {
    this.LOAD_DOCUMENT_FORMS({
      applicationId: this.applicationId,
      clientUsername: this.clientUsername
    }).then(() => {
      this.loading = false;
    }).catch(e => Err.handle(e));
    this.reloadSubmissionHistory();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations("ApplicationStore", [SET_DOCUMENT_FORM_SELECTION, SET_EDITING_DOCUMENT_FORM])), mapActions("ApplicationStore", [LOAD_DOCUMENT_FORMS, TOGGLE_FORM_SELECTED, PRINT_SELECTED_FORMS, PRINT_DOCUMENT_FORM, LOAD_SUBMISSION_HISTORY])), {}, {
    reloadSubmissionHistory() {
      const {
        clientUsername,
        applicationId
      } = this;
      this.LOAD_SUBMISSION_HISTORY({
        clientUsername,
        applicationId
      });
    },
    async handleMarkForDownload({
      formKey,
      mortgageType
    }) {
      this.TOGGLE_FORM_SELECTED({
        formKey,
        mortgageType,
        applicationId: this.applicationId
      });
    },
    async handlePrintSelected() {
      if (!this.canDownloadSelected) return;
      try {
        var _context, _context2;
        this.printing = true;
        const forms = _reduceInstanceProperty(_context = _filterInstanceProperty(_context2 = this.documentForms).call(_context2, form => !isEmpty(form.mortgagesSelected))).call(_context, (acc, form) => {
          var _context3;
          const baseForm = {
            type: form.formKey,
            province: form.province
          };
          const withMortgages = _mapInstanceProperty(_context3 = form.mortgagesSelected).call(_context3, mortgage => {
            return _objectSpread(_objectSpread({}, baseForm), {}, {
              mortgage
            });
          });
          acc.push(...withMortgages);
          return acc;
        }, []);
        const payload = {
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          forms
        };
        await this.PRINT_DOCUMENT_FORM(payload);
        this.handleClearAll();
        this.printing = false;
      } catch (e) {
        Err.handle(e);
      }
    },
    handleEditForm(form) {
      this.formToEdit = _objectSpread({}, form);
      this.editing = true;
      this.$refs.form.scrollTop = 0;
    },
    async handlePrintForm(form) {
      try {
        this.printing = true;
        const forms = [{
          type: form.formKey,
          province: form.province,
          mortgage: form.mortgageType,
          selectedApplicants: form.selectedApplicants
        }];
        const payload = {
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          forms
        };
        await this.PRINT_DOCUMENT_FORM(payload);
        this.printing = false;
      } catch (e) {
        Err.handle(e);
      }
    },
    async handleEditPrintForm() {
      try {
        this.saving = true;
        const forms = [{
          type: this.formToEdit.formKey,
          province: this.formToEdit.province,
          mortgage: this.formToEdit.mortgageType
        }];
        const payload = {
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          forms
        };
        await this.PRINT_DOCUMENT_FORM(payload);
      } catch (e) {
        Err.handle(e);
      } finally {
        this.saving = false;
      }
    },
    handleSelectAll() {
      this.SET_DOCUMENT_FORM_SELECTION({
        mortgagesSelected: this.currentMortgages,
        applicationId: this.applicationId,
        formSelectionEnabled: this.formSelectionEnabled
      });
    },
    handleClearAll() {
      this.SET_DOCUMENT_FORM_SELECTION({
        mortgagesSelected: [],
        applicationId: this.applicationId
      });
    },
    handleFinishEdit() {
      this.editing = false;
    },
    handleSaving(state) {
      this.saving = state;
    }
  })
});